import { useEffect, useState } from "react"
import { executeRequest, RequestType } from "../api/APIUtils"
import endpoints from "../api/endpoints"

export interface Auth0Config {
    loading: boolean
    auth0Enabled: boolean
    domain: string
    clientId: string
    audience: string
}

const DEFAULT_CONFIG: Auth0Config = {
    loading: true,
    auth0Enabled: false,
    domain: "",
    clientId: "",
    audience: ""
}

interface Auth0ConfigResponse {
    success: boolean
    auth0Enabled: boolean
    domain?: string
    clientId?: string
    audience?: string
}

const useAuth0Config = (): Auth0Config => {
    const [config, setConfig] = useState<Auth0Config>(DEFAULT_CONFIG)

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response: Auth0ConfigResponse = await executeRequest({
                    endpoint: endpoints.auth.AUTH0_CONFIG,
                    requestType: RequestType.GET
                })
                if (response.success && response.auth0Enabled) {
                    setConfig({
                        loading: false,
                        auth0Enabled: true,
                        domain: response.domain || "",
                        clientId: response.clientId || "",
                        audience: response.audience || ""
                    })
                } else {
                    setConfig({ ...DEFAULT_CONFIG, loading: false })
                }
            } catch {
                setConfig({ ...DEFAULT_CONFIG, loading: false })
            }
        }

        fetchConfig()
    }, [])

    return config
}

export default useAuth0Config
